'use client';

import { usePathname } from 'next/navigation';
import React, { useEffect } from 'react';
import { getIsNativePlatform } from '../../useCapacitor';
import { crashlyticsEvents } from '../../utils/crashlytics';

export const Crashlytics: React.FC = () => {
  const pathname = usePathname();

  useEffect(() => {
    if (!getIsNativePlatform()) return;
    crashlyticsEvents.pageView(pathname);
  }, [pathname]);

  return null;
};
